const CONFIG = {
  REACT_APP_API_URL: process.env.REACT_APP_API_URL,
};

export default CONFIG;
